$(document).on("focus", "[data-behaviour~='datepicker']", function () {
  $(this).datepicker({
    format: "yyyy-mm-dd",
    weekStart: 1,
    autoclose: true,
    todayHighlight: true
  })
})

$(document).on("changeDate", "[data-behaviour~='datepicker']", function (e) {
  var input = $(e.target)
  input.siblings("input").val(input.val())
})
